<template>
  <div v-if="msg" class="ui negative message appMessage hidden">
    <i v-if="closable" @click="hide" class="close icon"></i>
    <span>{{ msg }}</span>
  </div>
</template>

<script>
export default {
    props: {
        msg: {
            required: true
        },
        closable: {
            required: false,
            type: Boolean,
            default: false
        }
    },
    watch: {
        msg: function() {
            this.$nextTick(function() {
                if (this.msg) {
                    $(this.$el, '.hidden').transition('slide down');
                }
            });
        }
    },
    methods: {
        hide: function() {
            $(this.$el, '.visible').removeClass('visible').hide();
        }
    }
};
</script>
